import { useEffect } from "react";
import "./App.css";
import Licences from "./screens/Licences/Licences";
import Menubar from "./screens/Menubar/Menubar";
import "./styles/darkTheme.css";
import "./styles/lightTheme.css";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Users from "./screens/Users/Users";
import Login from "./screens/LoginandRegister/Login";
import Register from "./screens/LoginandRegister/Register";
import { getData, removeData } from "./utils/localstorage_constants";
import { IS_LOGGED } from "./utils/localstorage_variables";
import Product from "./screens/Product/Product";
import CommonSettings from "./utils/CommonSettings";

function App() {
  const location = useLocation();

  useEffect(() => {
    document.documentElement.className = "light-theme";

    CommonSettings.readAndSetCurrentServer();
  }, []);

  const ProtectedRoute = ({ children }) => {
    // removeData();
    const isLoggedIn = getData(IS_LOGGED);

    if (!isLoggedIn) {
      return <Navigate to="/login" replace />;
    }

    return children;
  };

  const PublicRoute = ({ children }) => {
    // removeData();

    const isLoggedIn = getData(IS_LOGGED); // don't use async here, localStorage is synchronous

    if (isLoggedIn) {
      return <Navigate to="/" replace />;
    }

    return children;
  };

  const shouldExcludeMenubars = () => {
    return !(
      location.pathname === "/login" || location.pathname === "/register"
    );
  };
  
  return (
    <div className="App">
      {shouldExcludeMenubars() && <Menubar />}
      <div>
        <Routes>
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Licences />
              </ProtectedRoute>
            }
          />
          <Route
            path="/product"
            element={
              <ProtectedRoute>
                <Product />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <Users />{" "}
              </ProtectedRoute>
            }
          />
          <Route
            path="/register"
            element={
              <PublicRoute>
                <Register />
              </PublicRoute>
            }
          />
        </Routes>
      </div>
    </div>
  );
}

export default App;
